import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import api from '../../lib/api';
import { Button } from '../ui/button';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../ui/dialog';

// "Who should have portal access?" – shown after a new entity joins a group. Nothing is granted unless ticked.
export const GrantPromptDialog = ({ clientId, creatorUserId, open, onClose }) => {
  const [users, setUsers] = useState([]);
  const [picked, setPicked] = useState([]);
  useEffect(() => {
    if (!open || !clientId) return;
    api.get(`/api/portal-access/clients/${clientId}/prompt`, { params: { creator_user_id: creatorUserId || undefined } }).then(({ data }) => {
      setUsers(data.users); setPicked(data.users.filter((u) => u.default && !u.has_access).map((u) => u.user_id));
    }).catch(() => setUsers([]));
  }, [open, clientId, creatorUserId]);
  const save = async () => {
    try { const { data } = await api.post(`/api/portal-access/clients/${clientId}/grant-batch`, { user_ids: picked }); toast.success(`${data.granted.length} user(s) granted`); onClose(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not save'); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="grant-prompt-dialog">
        <DialogHeader><DialogTitle>Who should have portal access?</DialogTitle></DialogHeader>
        {users.length === 0 && <p className="text-sm text-muted-foreground">No portal users in this group.</p>}
        {users.map((u) => (
          <label key={u.user_id} className="flex items-center gap-2 text-sm" data-testid={`grant-prompt-user-${u.user_id}`}>
            <input type="checkbox" disabled={u.has_access} checked={u.has_access || picked.includes(u.user_id)}
              onChange={(e) => setPicked(e.target.checked ? [...picked, u.user_id] : picked.filter((x) => x !== u.user_id))} />
            {u.name || u.email} <span className="text-muted-foreground">{u.email}{u.has_access ? ' · already has access' : ''}</span>
          </label>
        ))}
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} data-testid="grant-prompt-skip">No one for now</Button>
          <Button onClick={save} data-testid="grant-prompt-save">Save access</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
